import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "../../store";
import {
  hasPermission,
  hasAnyPermission,
} from "../../store/auth/authSlice";

interface PermissionBasedRouteProps {
  children: React.ReactNode;
  permission?: string;
  permissions?: string[];
  redirectTo?: string;
}

const PermissionBasedRoute: React.FC<PermissionBasedRouteProps> = ({
  children,
  permission,
  permissions,
  redirectTo,
}) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    const loginPath =
      redirectTo || `/${location.pathname.split("/")[1] || "en"}/auth/login`;
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Check permissions
  let hasAccess = false;

  if (permission) {
    hasAccess = hasPermission(user, permission);
  } else if (permissions && permissions.length > 0) {
    hasAccess = hasAnyPermission(user, permissions);
  } else {
    // If no permission specified, allow access (fallback to authenticated users)
    hasAccess = true;
  }

  if (!hasAccess) {
    // Redirect to dashboard if user doesn't have permission
    const dashboardPath = `/${location.pathname.split("/")[1] || "en"}/admin/dashboard`;
    return <Navigate to={dashboardPath} replace />;
  }

  return <>{children}</>;
};

export default PermissionBasedRoute;

